module.exports = "/assets/data/aeb7442a2b48bbc456aca3d325ae8c0b-SW8.data.json";